import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

// -------------------- Interfaces --------------------
export interface PhoneNumber {
  type: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  value: string;
}

export interface Email {
  value: string;
  type: string;
  primary: boolean;
  _id: string;
  createdAt: string;
  updatedAt: string;
}

export interface UserName {
  familyName: string;
  givenName: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
}

export interface Users {
  _id: string;
  status: string;
  phoneNumbers: PhoneNumber[];
  emails: Email[];
  userName: string;
  user_id: string;
  name: UserName;
  groups: string[];
}

export interface UserListParams {
  skip: number;
  limit: number;
  user_id?: string;
  userName?: string;
  email?: string;
}

export interface UserListResponse {
  success: boolean;
  code: number;
  data: {
    totalUsers: number;
    users: Users[];
  };
}

// -------------------- Service --------------------
export interface UserMetricsResponse {
  user: { total_count: number; total_active: number };
  group: { total_count: number };
  role: { total_count: number; total_active: number };
  user_invite: {
    total_count: number;
    total_accept_invites: number;
    total_user_register: number;
    success_rate: string;
    total_pending: number;
  };
}

class UsersService {
 async getUsers(params: UserListParams): Promise<UserListResponse> {
  try {
    const response = await apiClient.post(API_ENDPOINTS.USERS.LIST, params, );
    return response.data; // { success, code, data: { totalUsers, users } }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

async getTotalCounts(): Promise<UserMetricsResponse> {
  try {
    const response = await apiClient.get(API_ENDPOINTS.USERS.TOTAL_COUNTS);
    return response.data?.data;
  } catch (error) {
    console.error("Error fetching user metrics:", error);
    throw error;
  }
}
async getMappedUsers(group_id: string): Promise<any> {
  try {
    const response = await apiClient.get(API_ENDPOINTS.USERS.MAPPED_ROLES + `/${group_id}`, );
    return response.data; // { success, code, data: { totalUsers, users } }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

async createUser(user: any): Promise<any> {
  try {
    const response = await apiClient.post(API_ENDPOINTS.USERS.CREATE, user, );
    return response.data; // { success, code, data: { totalUsers, users } }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}
async userBulkUpload(data: any): Promise<any> {
  try {
    const response = await apiClient.post(
        API_ENDPOINTS.USERS.USER_BULK_UPLOAD,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    return response.data; 
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}


async updateUser(id:any,user: any): Promise<any> {
  try {
    const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE(id), user, );
    return response.data; // { success, code, data: { totalUsers, users } }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

async getUserById(user_id: string): Promise<any> {
   try {
 const response = await apiClient.get(API_ENDPOINTS.USERS.GET_BY_ID + `/${user_id}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

async deleteUser(user_id: string): Promise<any> {
  try {
    const response = await apiClient.delete(API_ENDPOINTS.USERS.DELETE + `/${user_id}`, );
    return response.data; // { success, code, data: { totalUsers, users } }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

}

export const usersService = new UsersService();
export default usersService;
